import { Schemas } from '~/clients/api-client'

import { useSpecialities } from '../'

type SpecialityQuery = Parameters<typeof useSpecialities>[0]

/**
 * This hook removes the unspecified specialities, which should not (and can't) be referenced
 * by a practitioner, OR-day or staffing configuration. Takes the same query as `useSpecialities`
 * and keeps every predicate the caller passes.
 */
export function useAssignableSpecialities<Q extends SpecialityQuery>(query?: Q) {
    const q = (query ?? {}) as Q
    return useSpecialities({ ...q, where: { ...q.where, AND: [...(q.where?.AND ?? []), { sections: { none: { dips_section_id: { isNullish: true } } } }] } })
}

/**
 * Returns the 3 letter short name of the speciality, as the `short_name` in our database is longer for some of the specialities.
 */
export const getSpecialityShortName = (speciality?: Schemas['SpecialityOut'] | null) => speciality?.short_name.toUpperCase().slice(0, 3) ?? '-'

/**
 * Returns the short name of the speciality, as the `name` in our database is a copy of `fieldOfStudy` in DIPS and is misleading and confusing
 */
export const getSpecialityName = (speciality?: Schemas['SpecialityOut'] | null) => speciality?.short_name ?? '-'
